// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1NqH4","info":"UpdateTermsInfo_info__2sJlF"};